export class GooglePayPaymentResponseError extends Error {
  constructor() {
    super('Failed to parse google payments response.');
    this.name = 'GooglePayPaymentResponseError';
  }
}
